@if (showDebugPanel) {
  <div class="debug-fab-container">
    <button type="button" class="debug-fab" (click)="togglePanel(); $event.stopPropagation()" title="Debug tools">
      🛠
    </button>
    @if (panelOpen()) {
      <div class="debug-dropdown">
        <button type="button" class="debug-action" (click)="deleteToken()">🗑 Delete Access Token</button>
        <button type="button" class="debug-action" (click)="invalidateRefreshToken()">
          🚫 Invalidate Refresh Token
        </button>
        <button type="button" class="debug-action" (click)="testRefresh()">🔄 Test Refresh</button>
        <button type="button" class="debug-action danger" (click)="deactivateAccount()">⛔ Deactivate Account</button>
      </div>
    }
  </div>
}
